<nav id="NavBar" class="navbar nav navbar-expand-custom navbar-inverse fixed-top" role="navigation" style="padding-left:0;">
    <div class="container-fluid" style="flex-wrap: nowrap; padding-left:0; padding-right:0;">
        <div class="navbar-header d-flex flex-row-reverse mr-auto" style="padding-bottom: 2px;">
            <a class="navbar-brand overflow" href="/Careers/Tasks" style="display: inline-flex;color:black; position: initial;">
                <img id="logo" style="display: inline;" [src]="logoUrl" alt="" />
                <span class="navbar-brand-text" style="font-size: 15px;margin-left: 10px;">
                    {{portalName}}
                </span>
            </a>
        </div>
        <div *ngIf="showLogout" class="navbar-header d-flex flex-row-reverse ml-auto" style="padding-bottom: 2px;">
            <ul class="nav navbar-nav navbar-right">
                <li>
                    <a style="text-decoration: none;" href="/Account/Logout?onboard=true" *ngIf="showON">
                        Logout
                        <div style="margin-left:5px;" class="oi oi-account-logout"></div>
                    </a>
                    <a style="text-decoration: none;" href="/Account/Logout?applicant=true" *ngIf="showAT">
                        Logout
                        <div style="margin-left:5px;"class="oi oi-account-logout"></div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</nav>
<router-outlet></router-outlet>
